export default __webpack_public_path__ + "static/media/product-listing-success.2df3c873.png";